module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h1"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('nav', {
    attrs: {
      "epub:type": "toc",
      "id": "toc"
    }
  }, [_c('ol', {
    staticClass: "tocol"
  }, [_c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/0_chapter1summernight"
    }
  }, [_vm._v("CHAPTER 1 - SUMMER NIGHT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/1_chapter2thatweekend"
    }
  }, [_vm._v("CHAPTER 2 - THAT WEEKEND")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/2_chapter3startled"
    }
  }, [_vm._v("CHAPTER 3 - STARTLED")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/3_chapter4treatmelikeasister"
    }
  }, [_vm._v("CHAPTER 4 - TREAT ME LIKE A SISTER")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/4_chapter5astheniaofheart"
    }
  }, [_vm._v("CHAPTER 5 - ASTHENIA OF HEART")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/5_chapter6better"
    }
  }, [_vm._v("CHAPTER 6 - BETTER")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/6_chapter7privateparty"
    }
  }, [_vm._v("CHAPTER 7 - PRIVATE PARTY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/7_chapter8importance"
    }
  }, [_vm._v("CHAPTER 8 - IMPORTANCE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('a', {
    attrs: {
      "href": "#/8_chapter9underthewarmlamp"
    }
  }, [_vm._v("CHAPTER 9 - UNDER THE WARM LAMP")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/9_chapter10walkupanddown",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 10 - WALK UP AND DOWN")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/10_chapter11successor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 11 - SUCCESSOR")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/11_chapter12betweenqingerandliuyue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 12 - BETWEEN QING'ER AND LIU YUE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter13sisbelievesinyou",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 13 - SIS BELIEVES IN YOU")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter14eyeopener",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 14 - EYE-OPENER")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter15alwaysremember",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 15 - ALWAYS REMEMBER")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/15_chapter16simple",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 16 - SIMPLE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/16_chapter17ineedyoutogivemesomepointers",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 17 - I NEED YOU TO GIVE ME SOME POINTERS!]")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/17_chapter18handteaching",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 18 - HAND TEACHING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/18_chapter19arrivingattheprovincialcapital",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 19 - ARRIVING AT THE PROVINCIAL CAPITAL")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/19_chapter20hewalkedallthewaytothenightmarket",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 20 - HE WALKED ALL THE WAY TO THE NIGHT MARKET …")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/20_chapter21letsjustletthisgo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 21 - LET'S JUST LET THIS GO")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/21_chapter22likethefirsttime",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 22 - LIKE THE FIRST TIME")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/22_chapter23speednotquality",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 23 - SPEED NOT QUALITY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/23_chapter24notbeingabletobealone",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 24 - NOT BEING ABLE TO BE ALONE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/24_chapter25intheautumnnight",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 25 - IN THE AUTUMN NIGHT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/25_chapter26nooneknows",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 26 - NO ONE KNOWS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/26_chapter27yourenotafraidofmeonabusinesstrip",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 27 - YOU'RE NOT AFRAID OF ME ON A BUSINESS TRIP")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/27_chapter28itactuallytastedlikechewingwax",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 28 - IT ACTUALLY TASTED LIKE CHEWING WAX …")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/28_chapter29olthreehasachancenow",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 29 - OL 'THREE HAS A CHANCE NOW")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/29_chapter30dontbelittleyourselfsomuch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 30 - DON'T BELITTLE YOURSELF SO MUCH")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/30_chapter31silentlyretractinghisgaze",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 31 - SILENTLY RETRACTING HIS GAZE …")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/31_chapter32balancefound",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 32 - BALANCE FOUND")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/32_chapter33itsbettertobewhereyouare",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 33 - IT'S BETTER TO BE WHERE YOU ARE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/33_chapter34iknow",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 34 - I KNOW")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/34_chapter35momanddadwerebothstunned",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 35 - MOM AND DAD WERE BOTH STUNNED …")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/35_chapter36wrapyourarmsaroundmywaist",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 36 - WRAP YOUR ARMS AROUND MY WAIST")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/36_chapter37thesellersrequestforhonor",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 37 - THE SELLER'S REQUEST FOR HONOR")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/37_chapter38greatface",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 38 - GREAT FACE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/38_chapter39smile",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 39 - SMILE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/39_chapter40noanswer",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 40 - NO ANSWER")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/40_chapter41serenity",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 41 - SERENITY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/41_chapter42itstimetogetoffwork",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 42 - IT'S TIME TO GET OFF WORK")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/42_chapter43whethersweetorspicy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 43 - WHETHER SWEET OR SPICY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/43_chapter44cerebralvertigo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 44 - CEREBRAL VERTIGO")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/44_chapter45dontbelittleyourselfsomuch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 45 - DON'T BELITTLE YOURSELF SO MUCH")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/45_chapter46oldthirdwasexpressionless",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 46 - OLD THIRD WAS EXPRESSIONLESS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/46_chapter47youstupidfool",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 47 - YOU STUPID FOOL!]")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/47_chapter48ithasnothingtodowithseniority",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 48 - IT HAS NOTHING TO DO WITH SENIORITY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/48_chapter49seerightthroughmymind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 49 - SEE RIGHT THROUGH MY MIND")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/49_chapter50asiexpected",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 50 - AS I EXPECTED")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/50_chapter51fallasleepagain",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 51 - FALL ASLEEP AGAIN")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/51_chapter52leastpromising",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 52 - LEAST PROMISING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/52_chapter53ivebeenbusylately",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 53 - I'VE BEEN BUSY LATELY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/53_chapter54notperceiving",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 54 - NOT PERCEIVING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/54_chapter55cantwait",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 55 - CAN'T WAIT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/55_chapter56didnotfollow",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 56 - DID NOT FOLLOW")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/56_chapter57decontamination",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 57 - DECONTAMINATION")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/57_chapter58unspeakabletaste",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 58 - UNSPEAKABLE TASTE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/58_chapter59thatkindofwinter",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 59 - THAT KIND OF WINTER")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/59_chapter60threatsandobstacles",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 60 - THREATS AND OBSTACLES")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/60_chapter61whatareyougawkingat",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 61 - WHAT ARE YOU GAWKING AT?!")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/61_chapter62highvigilance",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 62 - HIGH VIGILANCE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/62_chapter63doyourememberthepast",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 63 - DO YOU REMEMBER THE PAST?!")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/63_chapter64liuyuecalled",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 64 - LIU YUE CALLED")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/64_chapter65hadaglassofbitterwine",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 65 - HAD A GLASS OF BITTER WINE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/65_chapter66evenso",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 66 - EVEN SO …")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/66_chapter67youloveher",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 67 - YOU LOVE HER")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/67_chapter68itsallmyfault",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 68 - IT'S ALL MY FAULT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/68_chapter69folkcustoms",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 69 - FOLK CUSTOMS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/69_chapter70pretendnottosee",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 70 - PRETEND NOT TO SEE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/70_chapter71otherfeelings",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 71 - OTHER FEELINGS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/71_chapter72youreold",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 72 - YOU'RE OLD")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/72_chapter73moretypicalgroup",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 73 - MORE TYPICAL GROUP")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/73_chapter74specialrelation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 74 - SPECIAL RELATION")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/74_chapter75holdherbythethroat",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 75 - HOLD HER BY THE THROAT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/75_chapter76surfacesloppy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 76 - SURFACE SLOPPY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/76_chapter77iceshock",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 77 - ICE SHOCK")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/77_chapter78idontknowhowtothankyou",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 78 - I DON'T KNOW HOW TO THANK YOU")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/78_chapter79whatagreatleader",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 79 - WHAT A GREAT LEADER!")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/79_chapter80difficultday",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 80 - DIFFICULT DAY")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/80_chapter81afortuitousencounterinthenight",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 81 - A FORTUITOUS ENCOUNTER IN THE NIGHT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/81_chapter82tacitcongratulations",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 82 - TACIT CONGRATULATIONS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/82_chapter83liufeisgirlfriend",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 83 - LIU FEI'S GIRLFRIEND")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/83_chapter84emotionsonnewyearseve",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 84 - EMOTIONS ON NEW YEAR'S EVE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/84_chapter85paperairplane",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 85 - PAPER AIRPLANE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/85_chapter86thatunforgettablespringfestival",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 86 - THAT UNFORGETTABLE SPRING FESTIVAL")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/86_chapter87aguestatbrotheryangshouse",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 87 - A GUEST AT BROTHER YANG'S HOUSE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/87_chapter88lookaroundalldaylong",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 88 - LOOK AROUND ALL DAY LONG")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/88_chapter89amanwithoutaconscience",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 89 - A MAN WITHOUT A CONSCIENCE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/89_chapter90mountainresearch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 90 - MOUNTAIN RESEARCH")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/90_chapter91realintent",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 91 - REAL INTENT")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/91_chapter92ivebeenmakinglovetomyselfforsolong",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 92 - I'VE BEEN MAKING LOVE TO MYSELF FOR SO LONG")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/92_chapter93botharecomradesintherevolution",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 93 - BOTH ARE COMRADES IN THE REVOLUTION.")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/93_chapter94donotunderestimatethislist",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 94 - DO NOT UNDERESTIMATE THIS LIST")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/94_chapter95perseveranceandfirmness",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 95 - PERSEVERANCE AND FIRMNESS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/95_chapter96yanggesprivatebanquet",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 96 - YANG GE'S PRIVATE BANQUET")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/96_chapter97ministerzhangsteasing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 97 - MINISTER ZHANG'S TEASING")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/97_chapter98clinkwithliuyue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 98 - CLINK WITH LIU YUE")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/98_chapter99flawless",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 99 - FLAWLESS")])]), _vm._v(" "), _c('li', {
    staticClass: "table-of-content"
  }, [_c('span', {
    attrs: {
      "href": "#/99_chapter100thankthegodoffate",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER 100 - THANK THE GOD OF FATE")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 57
// module chunks = 0